import { render, staticRenderFns } from "./u-page-section-wide.vue?vue&type=template&id=6e5b15a7&scoped=true&"
import script from "./u-page-section-wide.vue?vue&type=script&lang=js&"
export * from "./u-page-section-wide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5b15a7",
  null
  
)

export default component.exports